
import { defineComponent, ref, reactive, toRefs, onMounted, watch, computed, nextTick } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, Nodata, Charts },
  setup(props: any, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      spinning: true,
      Latestone: '',
      LatestThree: '',
      option1: {},
      option2: {}
    })
    pageData.columns = computed(() => {
      return [
        {
          title: '时间段',
          dataIndex: 'time',
          key: 'time',
          width: '100px'
        },
        {
          title: '综合评级',
          dataIndex: 'Summary',
          key: 'Summary',
          width: '100px',
          ellipsis: true,
          slots: { customRender: 'ellipsis' }
        },
        {
          title: '评级分布',
          children: [
            {
              title: '买入',
              dataIndex: 'Buy',
              key: 'Buy',
              width: '100px',
              ellipsis: true,
              slots: { customRender: 'peopleCount' }
            },
            {
              title: '增持',
              dataIndex: 'Increase',
              key: 'Increase',
              width: '100px',
              ellipsis: true,
              slots: { customRender: 'peopleCount' }
            },
            {
              title: '中性',
              dataIndex: 'Middle',
              key: 'Middle',
              width: '100px',
              ellipsis: true,
              slots: { customRender: 'peopleCount' }
            },
            {
              title: '减持',
              dataIndex: 'Reduce',
              key: 'Reduce',
              width: '100px',
              ellipsis: true,
              slots: { customRender: 'peopleCount' }
            },
            {
              title: '卖出',
              dataIndex: 'Sell',
              key: 'Sell',
              width: '100px',
              ellipsis: true,
              slots: { customRender: 'peopleCount' }
            },
            {
              title: '总家数',
              dataIndex: 'All',
              key: 'All',
              width: '100px',
              ellipsis: true,
              slots: { customRender: 'peopleCount' }
            }
          ]
        }
      ]
    })
    const route = useRoute()
    const color: any = ['#379D21', '#74C25C', '#F6C638', '#FD6565', '#FF0000']
    let splitLinecolor = '#fff'
    let anchorcolor = '#D8D8DF'
    let pointercolor = '#AAAAAA'
    // 未评级颜色
    let notrated = '#303030'
    if (props.theme === 'dark') {
      splitLinecolor = '#121318'
      anchorcolor = '#7D7D7D'
      pointercolor = '#D8D8DF'
      notrated = '#D8D8DF'
    }
    function setOption1() {
      pageData.option1 = {
        tooltip: {
          show: false
        },
        series: [
          {
            // name: 'Pressure',
            type: 'gauge',
            splitNumber: 5,
            axisTick: {
              show: false
            },
            splitLine: {
              distance: -30,
              length: 40,
              lineStyle: {
                color: splitLinecolor,
                width: 1
              }
            },
            radius: '100',
            center: ['50%', 150],
            startAngle: 190,
            endAngle: -10,
            axisLabel: {
              show: false
            },
            anchor: {
              show: true,
              showAbove: true,
              size: 12,
              itemStyle: {
                borderWidth: 0,
                color: anchorcolor
              }
            },
            pointer: {
              show: pageData.Latestone > 0 ? true : false,
              width: 2,
              showAbove: false,
              itemStyle: {
                color: pointercolor
              }
            },
            title: {
              offsetCenter: [0, 50],
              fontSize: 14
            },
            axisLine: {
              lineStyle: {
                width: 10,
                color: [
                  [0.2, color[0]],
                  [0.4, color[1]],
                  [0.6, color[2]],
                  [0.8, color[3]],
                  [1, color[4]]
                ]
              }
            },
            data: [
              {
                value: pageData.Latestone - 10
              }
            ],
            detail: {
              valueAnimation: true,
              fontSize: 14,
              fontWeight: 'normal',
              color:
                pageData.Latestone === 100
                  ? color[4]
                  : pageData.Latestone === 80
                  ? color[3]
                  : pageData.Latestone === 60
                  ? color[2]
                  : pageData.Latestone === 40
                  ? color[1]
                  : pageData.Latestone === 20
                  ? color[0]
                  : notrated,
              offsetCenter: [0, 28],
              formatter: function(value: any) {
                const v = value + 10
                const str = v === 100 ? '买入' : v === 80 ? '增持' : v === 60 ? '中性' : v === 40 ? '减持' : v === 20 ? '卖出' : '未评级'
                return str
              }
            }
          }
        ]
      }
    }
    function setOption2() {
      pageData.option2 = {
        tooltip: {
          show: false
        },
        series: [
          {
            // name: 'Pressure',
            type: 'gauge',
            splitNumber: 5,
            axisTick: {
              show: false
            },
            splitLine: {
              distance: -30,
              length: 40,
              lineStyle: {
                color: splitLinecolor,
                width: 1
              }
            },
            radius: '100',
            center: ['50%', 150],
            startAngle: 190,
            endAngle: -10,
            axisLabel: {
              show: false
            },
            anchor: {
              show: true,
              showAbove: true,
              size: 12,
              itemStyle: {
                borderWidth: 0,
                color: anchorcolor
              }
            },
            pointer: {
              show: pageData.LatestThree > 0 ? true : false,
              width: 2,
              showAbove: false,
              itemStyle: {
                color: pointercolor
              }
            },
            title: {
              offsetCenter: [0, 50],
              fontSize: 14
            },
            axisLine: {
              lineStyle: {
                width: 10,
                color: [
                  [0.2, color[0]],
                  [0.4, color[1]],
                  [0.6, color[2]],
                  [0.8, color[3]],
                  [1, color[4]]
                ]
              }
            },
            data: [
              {
                value: pageData.LatestThree - 10
              }
            ],
            detail: {
              valueAnimation: true,
              fontSize: 14,
              fontWeight: 'normal',
              offsetCenter: [0, 28],
              color:
                pageData.LatestThree === 100
                  ? color[4]
                  : pageData.LatestThree === 80
                  ? color[3]
                  : pageData.LatestThree === 60
                  ? color[2]
                  : pageData.LatestThree === 40
                  ? color[1]
                  : pageData.LatestThree === 20
                  ? color[0]
                  : notrated,
              formatter: function(value: any) {
                const v = value + 10
                const str = v === 100 ? '买入' : v === 80 ? '增持' : v === 60 ? '中性' : v === 40 ? '减持' : v === 20 ? '卖出' : '未评级'
                return str
              }
            }
          }
        ]
      }
    }
    watch(
      () => ((props || {}).pageSourceData || {}).ReportRating,
      (val: any) => {
        const data = JSON.parse(JSON.stringify(val))
        if ((data.Detail || []).length) {
          data.Detail.forEach((item: any, i: number) => {
            item.index = '' + i
            item.time = item.Period ? '最近' + (item.Period || 30) / 30 + '个月内' : '—'
            item.Summary =
              item.Summary === 1
                ? '买入'
                : item.Summary === 2
                ? '增持'
                : item.Summary === 3
                ? '中性'
                : item.Summary === 4
                ? '减持'
                : item.Summary === 5
                ? '卖出'
                : item.Summary === 6
                ? '未评级'
                : '—'
          })
          const Latestone = data.Latestone
          const LatestThree = data.LatestThree
          pageData.data = data.Detail
          pageData.Latestone = Latestone === 10 ? 100 : Latestone === 13 ? 80 : Latestone === 20 ? 60 : Latestone === 30 ? 40 : Latestone === 33 ? 20 : -10
          pageData.LatestThree =
            LatestThree === 1 ? 100 : LatestThree === 2 ? 80 : LatestThree === 3 ? 60 : LatestThree === 4 ? 40 : LatestThree === 5 ? 20 : -10
          setOption1()
          setOption2()
        }
        nextTick(() => {
          pageData.spinning = false
        })
      },
      { deep: true }
    )

    return {
      ...toRefs(pageData)
    }
  }
})
